module.exports = {
  POINTS: 'points',
  CURRENCY: 'currency'
}
